<template>
  <v-card class="mx-auto pa-2"  max-width="600">
    <v-card-title class="justify-center" style="position: relative;">
      <h2>
        NOVA
        {{
          cadOferta.promocao ?
          'PROMOÇÃO'
          :
          'OFERTA'
        }}
      </h2>
      <v-btn
        fab
        x-small
        v-if="step === 1"
        color="primary"
        @click="step = 2"
        style="position: absolute; top: 1em; right: 1em;"
      >
        <v-icon>add</v-icon>
      </v-btn>
    </v-card-title>
    <v-alert v-show="alerta" :type="tipo" style="width: 100%;" class="pa-2" :value="true">
        <h4>{{alerta}}</h4>
    </v-alert>
    <v-divider v-show="alerta"></v-divider>
    <v-stepper v-model="step" class="elevation-0">
      <v-stepper-items>
        <v-stepper-content class="pa-0 ma-0" step="1">
          <v-container grid-list-md>
            <v-list class="transparent" subheader>
              <template v-for="(oferta, index) in ofertas">
                <v-list-item :key="index">
                  <v-list-item-avatar>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <v-icon v-on="on" :color="`${oferta && oferta.para_assinantes ? 'secondary' : ''}`">
                          {{ oferta.promocao ? 'sell' : 'percent' }}
                        </v-icon>
                      </template>
                      <span>
                        Válida para o empresa
                      </span>
                    </v-tooltip>
                  </v-list-item-avatar>
                  <v-list-item-avatar>
                    <span
                      :class="`${oferta && oferta.para_assinantes ? 'secondary' : ''}--text`"
                    >
                      <span v-if="oferta.desconto_reais">
                        {{ oferta.desconto_reais | currency({fractionCount: 2})}}
                      </span>
                      <span v-else>
                        {{ oferta.percentual_desconto }}%
                      </span>
                    </span>
                  </v-list-item-avatar>
                  <v-list-item-content>
                    <v-list-item-subtitle
                      :class="`${oferta.para_assinantes ? 'secondary' : ''}--text pt-1`"
                    >
                      {{
                        oferta.promocao ?
                        'Promoção'
                        :
                        'Oferta'
                      }}
                    </v-list-item-subtitle>
                  </v-list-item-content>
                  <v-list-item-action v-if="oferta.promocao">
                    <template v-if="new Date(`${oferta.data_fim}T23:59:59`) >= new Date()">
                      <v-list-item-action-text
                        :class="`${oferta && oferta.para_assinantes ? 'secondary' : ''}--text`"
                      >
                        <span>
                          Início: {{ oferta.data_inicio | formatDate('DD/MM') }}
                        </span>
                        <v-spacer/>
                        <span>
                          Fim: {{ oferta.data_fim | formatDate('DD/MM') }}
                        </span>
                      </v-list-item-action-text>
                    </template>
                    <template v-else>
                      <v-list-item-action-text
                        style="color: #8B0000;"
                        class="ml-3"
                      >
                        Data expirou
                      </v-list-item-action-text>
                    </template>
                  </v-list-item-action>
                  <v-list-item-avatar v-if="oferta.para_assinantes">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <v-icon
                          class="ml-3"
                          v-on="on"
                          color="secondary"
                        >
                          star
                        </v-icon>
                      </template>
                      Apenas Para Assinantes
                    </v-tooltip>
                  </v-list-item-avatar>
                  <v-list-item-action style="flex-direction: row; display: flex; width: 30%; justify-content: space-around;">
                    <v-flex xs5>
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                          <v-btn icon @click="function () {
                              ofertaSelected = oferta
                              cancelarOfertaDialog = true
                            }"
                            color="error"
                            v-on="on"
                          >
                            <v-icon>delete</v-icon>
                          </v-btn>
                        </template>
                        <span>
                          Remover oferta
                        </span>
                      </v-tooltip>
                    </v-flex>
                    <v-spacer></v-spacer>
                    <v-flex xs5>
                      <v-menu offset-x max-width="250" right v-if="oferta.promocao">
                        <template v-slot:activator="{ on }">
                          <v-btn icon v-on="on">
                            <v-icon :color="`${oferta && oferta.para_assinantes ? 'secondary' : 'grey'} darken-2`">more_vert</v-icon>
                          </v-btn>
                        </template>
                        <v-list dense class="pa-0">
                          <v-list-item ripple @click="carregarBanner(oferta)">
                            <v-list-item-content>
                              <v-list-item-title
                                class="font-weight-light body-1 success--text text-xs-center"
                              >CARREGAR BANNER</v-list-item-title>
                            </v-list-item-content>
                            <v-list-item-action>
                              <v-icon color="success">image</v-icon>
                            </v-list-item-action>
                          </v-list-item>
                          <v-list-item
                            ripple
                            @click="() => { ofertaSelected = oferta; cancelarOfertaDialog = true }"
                          >
                            <v-list-item-content>
                              <v-list-item-title
                                class="font-weight-light body-1 error--text text-xs-center"
                              >CANCELAR PROMOÇÃO</v-list-item-title>
                            </v-list-item-content>
                            <v-list-item-action>
                              <v-icon color="error">close</v-icon>
                            </v-list-item-action>
                          </v-list-item>
                        </v-list>
                      </v-menu>
                    </v-flex>
                  </v-list-item-action>
                </v-list-item>
              </template>
              <v-list-item v-if="!ofertas || ofertas.length === 0">
                <v-list-item-content>
                  <v-list-item-title class="font-weight-light body-1 text-xs-center">
                    Nenhuma oferta cadastrada
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-container>
        </v-stepper-content>
        <v-stepper-content class="pa-0 ma-0" step="2">
          <v-container grid-list-md>
            <v-form v-model="valid1" ref="formFirstStep">
              <v-layout row wrap>
                <v-flex xs4 class="ma-0 pa-0">
                  <v-text-field
                    v-model="desconto"
                    label="Percentual do desconto"
                    required
                    suffix="%"
                    :rules="[
                      () => desconto <= 100 || 'Desconto inválido',
                      () => desconto >= 1 || `O desconto mímino deve ser de 1%`
                    ]"
                  ></v-text-field>
                </v-flex>
                <v-spacer></v-spacer>
                <v-flex xs7 class="ma-0 pa-0">
                  <v-select
                    label="Selecione a categoria"
                    :items="categorias"
                    item-text="nome"
                    item-value="id"
                    v-model="cadOferta.categoria"
                    clearable
                  />
                </v-flex>
                <v-flex xs12 class="ma-0 pa-0">
                  <v-select
                    label="Para"
                    :items="[{ nome: 'Todos os itens da categoria', id: 0 }, ...todos_itens]"
                    item-text="nome"
                    item-value="id"
                    v-model="cadOferta.item"
                  />
                </v-flex>
                <v-flex xs12>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-flex xs12 class="ma-0 pa-0" v-on="on">
                        <v-switch
                            slot="activator"
                            class="ml-4"
                            v-model="cadOferta.promocao"
                            label="É uma promoção"
                            color="info"
                          />
                        </v-flex>
                      </template>
                      <span>
                        {{
                          cadOferta.promocao ?
                          'Ao desativar esse recurso você terá um desconto válido por tempo indeterminado.'
                          :
                          'Ao ativar esse recurso você terá um desconto válido por um tempo determinado.'
                        }}
                      </span>
                  </v-tooltip>
                </v-flex>
                <v-flex
                  aling-self-center
                  style="
                      justify-content: center;
                      display: flex;
                  "
                  class="ma-0 pa-0"
                  v-if="planos.length > 0"
                >
                  <v-tooltip bottom>
                    <v-switch class="mr-4" slot="activator" v-model="cadOferta.para_assinantes" color="secondary">
                      <template v-slot:label>
                          Para Assinantes
                      </template>
                    </v-switch>
                    <span style="font-size: 1.2em;">
                      {{
                        !cadOferta.para_assinantes ?
                        'Ativando essa função, A promoção estará disponível para os assinantes do programa de assinatura.' :
                        'Ao Desativar essa função a promoção estará disponível para todos os clientes que comprarem em seu posto'
                      }}
                    </span>
                  </v-tooltip>
                </v-flex>
                <template v-if="cadOferta.item === 0">
                  <v-flex xs12 class="mt-2">
                    <h4 class="text-center secondary--text mb-2" style="font-weight: normal;">
                      Selecione os itens que não farão parte dessa promoção
                    </h4>
                  </v-flex>
                  <v-flex xs12 class="ma-0 pa-0" style="flex-direction: row; display: flex;">
                    <v-flex xs10 class="pa-0 ma-0">
                        <v-select
                          label="Selecione um Item"
                          :items="todos_itens"
                          item-text="nome"
                          v-model="item_list"
                          return-object
                          clearable
                        />
                    </v-flex>
                    <v-flex xs2 style="justify-content: center; display: flex;" class="pa-0 ma-0">
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                          <v-btn :disabled="item_list === undefined" @click="ListAdd()" v-on="on" icon color="primary" style="margin-top:2.5em;"><v-icon small>add</v-icon></v-btn>
                        </template>
                        Adicionar combustível a lista
                      </v-tooltip>
                    </v-flex>
                  </v-flex>
                  <v-flex xs12 class="ma-0 pa-0">
                    <v-layout justify-center wrap>
                      <v-flex xs12 class="mt-3">
                        <h3 style="text-align: center;" class="grey--text" v-if="itens_nao_ofertados.length > 0">
                          Itens que não incluídos
                        </h3>
                      </v-flex>
                      <v-flex xs12 v-if="itens_nao_ofertados.length > 0">
                        <v-list style="background-color:#F5F5F5">
                          <v-list-item v-for="(ino, index) in itens_nao_ofertados" :key="index">
                            <v-list-item-avatar>
                              <svg-filler
                                v-if="ino.categoria.referencia === 'combustivel'"
                                :path="ino.combustivel.icone ? require(`@/assets/combs/${ino.combustivel.icone}.svg`) : require(`@/assets/combs/gas.svg`)"
                                width="30px"
                                height="30px"
                                :fill="ino.preco ? ino.combustivel.color : 'grey'"
                              />
                              <v-icon v-else :color="ino.categoria.cor">
                                {{ ino.categoria.icone }}
                              </v-icon>
                            </v-list-item-avatar>
                            <v-list-item-content>
                              <v-list-item-title>{{ino.nome}}</v-list-item-title>
                            </v-list-item-content>
                            <v-list-item-action>
                              <v-btn icon @click="removerDalista(index)">
                                <v-icon>close</v-icon>
                              </v-btn>
                            </v-list-item-action>
                          </v-list-item>
                        </v-list>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </template>
              </v-layout>
            </v-form>
          </v-container>
        </v-stepper-content>
        <v-stepper-content step="3" class="pa-0">
          <v-container grid-list-md>
            <v-form v-model="valid2" ref="formSecondStep">
              <v-layout row wrap>
                <v-flex xs6>
                  <v-menu
                    ref="menuInicio"
                    v-model="menuInicio"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    max-width="290px"
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="cadOferta.data_inicio"
                        label="Início"
                        hint="Início da promoção"
                        persistent-hint
                        prepend-icon="event"
                        readonly
                        @blur="date_inicio = parseDate(cadOferta.data_inicio)"
                        v-on="on"
                        required
                        :rules="[
                          (v) => !!v || 'A data inicial é obrigatória'
                        ]"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="date_inicio"
                      no-title
                      @input="menuInicio = false"
                      locale="pt-br"
                      :allowed-dates="(date) => {
                        return Date.parse(date) >= today
                      }"
                    ></v-date-picker>
                  </v-menu>
                </v-flex>
                <v-flex xs6>
                  <v-menu
                    ref="menu"
                    v-model="menu"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    max-width="290px"
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="cadOferta.data_fim"
                        label="Fim"
                        hint="Fim da promoção"
                        persistent-hint
                        prepend-icon="event"
                        readonly
                        @blur="date = parseDate(cadOferta.data_fim)"
                        v-on="on"
                        required
                        :rules="[
                          (v) => !!v || 'A data final é obrigatória'
                        ]"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                    v-model="date"
                    no-title
                    @input="menu = false"
                    locale="pt-br"
                    :allowed-dates="(date) => {
                        return Date.parse(date) >= data_inicio_teste
                    }"
                    />
                  </v-menu>
                </v-flex>
              </v-layout>
            </v-form>
          </v-container>
        </v-stepper-content>
      </v-stepper-items>
    </v-stepper>
    <v-card-actions>
      <v-flex :xs6="step > 1" :xs12="step === 1">
        <v-btn color="grey" text @click="voltarTela()" block>
          {{ step === 1 ? 'FECHAR' : 'VOLTAR' }}
        </v-btn>
      </v-flex>
      <v-divider vertical v-if="step > 1"></v-divider>
      <v-flex xs6 v-if="step > 1">
        <v-btn color="green darken-1" text @click="continuarTela()" block>
          {{ step === 2 || !this.cadOferta.promocao ? 'CONFIRMAR' : 'CONTINUAR' }}
        </v-btn>
      </v-flex>
    </v-card-actions>
    <v-dialog
      width="600"
      persistent
      v-model="dialogBannerPromocional"
    >
      <carregar-banner
        v-if="promocaoBanner"
        @close="(url_imagem_promocao) => closeBannerDialog(promocaoBanner, url_imagem_promocao)"
        :promocao="promocaoBanner"
      ></carregar-banner>
    </v-dialog>
    <v-dialog v-model="cancelarOfertaDialog" persistent max-width="320">
        <v-card>
          <v-card-title class="headline">Interromper esta oferta?</v-card-title>
          <v-card-text>Depois de confirmar, seus clientes não poderão mais comprar com este desconto!</v-card-text>
          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12>
                  <v-textarea
                    outline
                    v-model="motivoCancelamento"
                    name="input-7-4"
                    label="Motivo do cancelamento"
                    value
                  ></v-textarea>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-card-actions class="justify-space-between">
            <v-btn color="grey" text @click="cancelarOfertaDialog = false">Não!</v-btn>
            <v-btn
              color="green darken-1"
              text
              @click="cancelarOferta(ofertaSelected, motivoCancelamento)"
            >Confirmar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
  </v-card>
</template>

<script>
import { VMoney } from 'v-money'
import CarregarBanner from '@/components/CarregarBanner'
export default {
  components: { CarregarBanner },
  data () {
    return {
      step: 1,
      opcao: 'Posto',
      valid1: false,
      valid2: false,
      valid4: false,
      motivoCancelamento: '',
      cancelarOfertaDialog: false,
      renderComponent: true,
      date: null,
      limitar_pagamento: false,
      tipo_pagamento: null,
      date_inicio: null,
      menu: false,
      menuInicio: false,
      desconto: 0,
      planos: [],
      itens_nao_ofertados: [],
      todos_itens: [],
      categorias: [],
      item_list: undefined,
      alerta: undefined,
      dialogBannerPromocional: false,
      promocaoBanner: null,
      tipo: 'error',
      ofertas: [],
      money: {
        decimal: ',',
        thousands: '.',
        prefix: 'R$ ',
        precision: 2,
        masked: false
      },
      moneyFinal: {
        decimal: ',',
        thousands: '.',
        prefix: 'R$ ',
        precision: 2,
        masked: false
      },
      cadOferta: {
        percentual_desconto: 0,
        promocao: false,
        disponivel: true,
        ativo: true,
        novo: true,
        data_inicio: null,
        data_fim: null,
        today: null,
        data_inicio_teste: null,
        para_assinantes: false,
        combustiveis_nao_ofertados: [],
        itens_nao_ofertados: [],
        categoria: 0,
        item: 0
      }
    }
  },
  watch: {
    limitar_pagamento (val) {
      if (!val) {
        this.tipo_pagamento = null
      }
    },
    date (val) {
      this.cadOferta.data_fim = this.formatDate(this.date)
    },
    date_inicio (val) {
      this.cadOferta.data_inicio = this.formatDate(this.date_inicio)
      this.data_inicio_teste = Date.parse(val)
    },
    desconto (val) {
      if (val) {
        this.cadOferta.percentual_desconto = val
      }
    },
    tipo_pagamento (val) {
      this.cadOferta.tipos_pagamento = []
      if (val) {
        this.cadOferta.tipos_pagamento.push(val)
      }
    },
    'cadOferta.item' (val) {
      if (val !== 0) {
        this.itens_nao_ofertados = []
      }
    },
    'cadOferta.categoria' () {
      this.pegarTodosItens()
    }
  },
  computed: {
    titulo () {
      const tipo = this.cadOferta.promocao ? 'Promoção' : 'Oferta'
      switch (this.step) {
        case 1:
          return 'Ofertas e Promoções'
        case 2:
          return `Cadastrar ${tipo}`
        case 3:
          return `Data de valida da ${tipo}`
        default:
          return 'Cadastrar Oferta'
      }
    },
    empresa () {
      return this.$store.getters.empresa
    },
    tiposPagamento () {
      return this.$store.getters.tiposPagamento
    }
  },
  beforeMount () {
    this.pegarCategorias()
    this.today = new Date().toISOString().substr(0, 10)
    this.today = Date.parse(this.today)
    // this.pegarPlanos()
    this.pegarTodosItens()
    this.carregarOfertas()
  },
  methods: {
    closeBannerDialog (oferta, bannerUrl) {
      if (bannerUrl) oferta.url_imagem_promocao = bannerUrl
      this.promocaoBanner = null
      this.dialogBannerPromocional = false
    },
    cancelarOferta (oferta, motivoCancelamento) {
      const data = {
        id: oferta.id,
        method: 'DELETE',
        body: {
          empresa: this.empresa.cnpj,
          motivo_cancelamento: motivoCancelamento,
          opcao_exclusao: 2
        }
      }
      this.$store
        .dispatch('oferta', data)
        .then(() => {
          motivoCancelamento = ''
          oferta = null
          this.cancelarOfertaDialog = false
          this.carregarOfertas()
        })
    },
    carregarOfertas () {
      this.$store.dispatch(
        'oferta',
        {
          method: 'GET',
          parameters: {
            empresa: this.empresa.cnpj
          }
        }
      ).then(json => {
        this.ofertas = json
      })
    },
    activeAlert (text, type) {
      this.alerta = text
      this.tipo = type
      const interval = setInterval(() => {
        this.alerta = undefined
        clearInterval(interval)
      }, 5000)
    },
    fechar () {
      this.$refs.formFirstStep.reset()
      this.$refs.formSecondStep.reset()
      this.limitar_pagamento = false
      this.step = 1
      this.$emit('fechar')
    },
    ListAdd () {
      let itemExiste = false
      for (const i in this.itens_nao_ofertados) {
        if (this.itens_nao_ofertados[i].id === this.item_list.id) {
          itemExiste = true
        }
      }
      if (itemExiste) {
        this.activeAlert('Esse item já foi inserido.', 'error')
      } else {
        this.itens_nao_ofertados.push(this.item_list)
      }
    },
    removerDalista (index) {
      this.itens_nao_ofertados.splice(index, 1)
    },
    pegarPlanos () {
      const data = { ativo: true }
      data.empresa = this.empresa.cnpj
      this.$store.dispatch('pegarPlanos', data).then(json => {
        this.planos = json
      })
    },
    continuarTela () {
      switch (this.step) {
        case 2:
          if (this.$refs.formFirstStep.validate()) {
            if (this.cadOferta.promocao) {
              this.step++
            } else {
              this.confirmar()
            }
          }
          break
        case 3:
          if (this.$refs.formSecondStep.validate()) {
            this.confirmar()
          }
      }
    },
    voltarTela () {
      switch (this.step) {
        case 1:
          this.fechar()
          break
        default:
          this.step--
      }
    },
    formatDate (date) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      return `${day}/${month}/${year}`
    },
    parseDate (date) {
      if (!date) return null

      const [day, month, year] = date.split('/')
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    },
    confirmar () {
      if (this.cadOferta.item === 0 && this.itens_nao_ofertados.length > 0) {
        this.cadOferta.itens_nao_ofertados = []
        this.itens_nao_ofertados.map(
          (ino) => this.cadOferta.itens_nao_ofertados.push(
            ino.id
          )
        )
      }

      if (!this.cadOferta.percentual_desconto || !this.cadOferta.percentual_desconto === 0) {
        this.activeAlert('O percentual de precisa ser superior a zero', 'error')
        return
      }

      const texto = this.cadOferta.promocao ? 'Promoção' : 'Oferta'

      const data = {
        method: 'POST',
        body: {
          ...this.cadOferta,
          data_fim: this.parseDate(this.cadOferta.data_fim),
          data_inicio: this.parseDate(this.cadOferta.data_inicio),
          item: this.cadOferta.item === 0 ? null : this.cadOferta.item,
          categoria: this.cadOferta.categoria ? this.cadOferta.categoria : null,
          empresa: this.empresa.cnpj
        }
      }

      this.$store
        .dispatch('oferta', data)
        .then(() => {
          this.activeAlert(`${texto} cadastrada com sucesso`, 'success')
          this.$store.dispatch('setSuccess', `${texto} cadastrada com sucesso`)
          this.$emit('carregar')
          this.carregarOfertas()
          this.step = 1
          this.fechar()
        })
        .catch(() => {
          this.activeAlert(`Não foi possível inserir a ${texto}`, 'error')
          // this.fechar()
        })
    },
    pegarCategorias () {
      this.$store.dispatch('pegarCategorias').then(json => {
        this.categorias = json.filter(c => c.referencia !== 'combustivel')
      })
    },
    pegarTodosItens () {
      const data = {
        method: 'GET',
        parameters: {
          empresa: this.empresa.cnpj,
          empresa__cnpj: this.empresa.cnpj
        }
      }
      if (this.cadOferta.categoria) {
        data.parameters.categoria = this.cadOferta.categoria
      }
      this.$store.dispatch('itens', data).then(json => {
        this.todos_itens = json
      })
    }
  },
  directives: { money: VMoney }
}
</script>
